import Header from '@/components/Header.vue'
import Login from '@/components/auth/Login'
import Register from '@/components/auth/Register.vue'
import User from '@/components/User.vue'
import InviteRegister from '@/components/auth/InviteRegister.vue'
import { getCurrentFirebaseUser } from '@/platform/auth/services/authService.js'

export default [
    {
        path: '/login',
        name: 'login',
        components: {
            header: Header,
            content: Login
        },
        props: {
            header: true,
            content: true
        },
        beforeEnter(to, from, next) {
            let user = getCurrentFirebaseUser()
            if (user && !user.isAnonymous) {
                next('/dashboard')
            } else {
                next()
            }
        }
    },
    {
        path: '/register',
        name: 'register',
        components: {
            header: Header,
            content: Register
        },
        props: {
            header: true,
            content: true
        },
        beforeEnter(to, from, next) {
            let user = getCurrentFirebaseUser()
            if (user && !user.isAnonymous) {
                next('/dashboard')
            } else if (to.query.redirect) {
                next() // passing query params over from login to register.
            } else if (from.name == "login" && from.query.redirect) {
                next({
                    name: to.name,
                    query: { redirect: from.query.redirect }
                })
            }
            else next()
        }
    },
    {
        path: '/invitation/user',
        name: 'inviteUser',
        components: {
            header: Header,
            content: InviteRegister
        },
        props: {
            header: true,
            content: true
        },
        beforeEnter(to, from, next) {
            let user = getCurrentFirebaseUser()
            if (user && !user.isAnonymous) {
                next('/dashboard')
            } else {
                next()
            }
        }
    },
    {
        path: '/user/:id?',
        name: 'user',
        components: {
            header: Header,
            content: User
        },
        props: {
            header: true,
            content: true
        },
        beforeEnter(to, from, next) {
            let user = getCurrentFirebaseUser()
            if (user && !user.isAnonymous) {
                next()
            } else {
                next('/login')
            }
        }
    }
]


// WEBPACK FOOTER //
// ./src/router/user/index.js